





















































































































































































































































































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { EventBus } from '@/event-bus';
import axios from 'axios';
import Swal from 'sweetalert2';
import Grid from '@/components/grid/Grid.vue';
import GridColumn from '@/components/grid/GridColumn.vue';
import DonorsTab from './DonorsTab.vue';
import RelativeDonorsTab from './RelativeDonorsTab.vue';
import BaseEdit from './BaseEdit';
import moment from 'moment';
import FormHelper from '@/helpers/form.helper';
import FileUploader from '@/components/FileUploader.vue';

@Component({
  components: {
    'grid': Grid,
    'grid-column': GridColumn,
    'donors-tab': DonorsTab,
    'relative-donors-tab': RelativeDonorsTab,
    'file-uploader': FileUploader,
  },
})
export default class Edit extends BaseEdit {
  form = {
    comment: '',
    registerComment: '',
    coordinatorNotes: '',
    diagnosisId: '',
    organizationCode: '',
    statuses: [],
    genders: [],
    gendersLocalized: [],
    diagnoses: [],
    bloodTypes: [],
    cmvStatuses: [],
    rhs: [],
    hlas: [],
    history: [],
    number: '',
    isEmailNotification: false,
    emailNotificationDate: Date,
    transplantationDate: 'init',
    hasDoctorConclusion: false,
    hasUnrelatedSearchConfirm: false,
    hasPersonalDataConfirm: false,
    doctorConclusionFileInfo: null,
    unrelatedSearchConfirmFileInfo: null,
    personalDataConfirmFileInfo: null,
    timeoutUserGroups: [],
  } as any;

  public STATUS_RELATIVE_DONOR = 10;
  public STATUS_SWITCH_TO_UNRELATIVE_PROGRAM = 11;
  public STATUS_ACTIVATION = 4;
  public STATUS_COMPLETE = 5;
  public STATUS_ARCHIVE = 8;
  public REJECT_STATUSES = [6, 7];
  public COMPLETE_STATUSES = [5, 8];

  public tabIndex: any = 0;

  public moment = moment;
  public init = false;

  get isDonorTabVisible() {
    return !this.form.isNew && (!this.isRelativePatient ||
           [ this.STATUS_RELATIVE_DONOR, this.STATUS_ACTIVATION, this.STATUS_COMPLETE ].indexOf(this.form.status) >= 0);
  }

  public newTkm() {
     // @ts-ignore
     this.$swal({
        icon: 'warning',
        title: this.$t('Предупреждение'),
        text: 'Вы действительно хотите выполнить повторную ТКМ этому пациенту?',
        buttons: [this.$t('Нет'), this.$t('Да')],
      }).then(async (doChange: any) => {
        if (doChange) {
          EventBus.$emit('showThrobber');
          axios.get('/Patients/NewTkm?number=' + this.form.number)
              .then((response) => {
                location.href = '/patients/' + response.data;
          }).catch((error) => {
            EventBus.$emit('hideThrobber');
            if (error.data.notificationType === 0) {
              Swal(
                this.$t('Информация') as string,
                error.data.message,
                'warning',
              );
            }
          });
        }
      });
  }

  async onFindDonor() {
    await this.submitWithFile("/patients", false);

    await this.findDonor();
    if (!this.isStatusChangeError) {
      this.form.status = 1;
    }
  }

  tryChangeStatus(newStatus: any) {
    if (this.form.status === newStatus) {
      return;
    }
    if (this.form.status > newStatus || this.REJECT_STATUSES.includes(newStatus)) {
      // @ts-ignore
      const newStatusName = this.form.statuses.filter((s) => s.key == newStatus)[0].value;
      let msgText =
        '<span style="color:black; font-size: 18px">Это действие отменит текущий статус. <br/>Будет выставлен предыдущий статус <b>"' +
        newStatusName +
        '"</b>. <br/>Выполнить операцию?</span>';
      if (this.REJECT_STATUSES.includes(newStatus)) {
        msgText =
          '<span style="color:black; font-size: 18px">Вы действительно хотите сделать <span style="color:red">ОТКАЗ</span>? <br/>В результате будет выставлен статус <b>"' +
          newStatusName +
          '"</b>. <br/> Выполнить операцию?</span>';
      }
      const msgHtml = document.createElement("div");
      msgHtml.innerHTML = msgText;
      //@ts-ignore
      this.$swal({
        icon: "warning",
        title: this.$t("Предупреждение"),
        content: msgHtml,
        buttons: [this.$t("Нет"), this.$t("Да")],
      }).then((doChange: any) => {
        if (doChange) {
          this.onStatusChanged(newStatus);
        }
      });
    } else {
      this.onStatusChanged(newStatus);
    }
  }

  async onTcReject() {
    this.onStatusChanged(6);
  }

  get contactTC() {
    var contacts = [
      this.form.createUserName || "",
      this.form.createUserEmail || "",
      this.form.сreateUserPhone,
      this.form.сreateUserAdphone,
    ];
    contacts = contacts.filter((t) => t);

    return contacts.join(", ");
    // return `${this.form.createUserName || ''}, ${this.form.createUserEmail || ''}, ${this.form.сreateUserPhone}, ${this.form.сreateUserAdphone}`;
  }

  @Watch("form.createUserId")
  onCreateUserIdChanged(val: string, oldVal: string) {
    if (this.init) {
      const tcUser = this.form.tcUsersData.find((column: any) => column.id == val);
      this.form.createUserName = tcUser ? tcUser.name : "";
      this.form.createUserEmail = tcUser ? tcUser.email : "";
      this.form.сreateUserPhone = tcUser ? tcUser.phone : "";
      this.form.сreateUserAdphone = tcUser ? tcUser.additionalPhone : "";
    }
    this.init = true;
  }

  async onStatusChanged(statusNumber: number) {
    if (!this.isDataLoaded) {
      return;
    }

    const status = this.getStatusByKey(statusNumber);
    if (status.value == "Поиск донора") {
      await this.onFindDonor();
    } else {
      const oldStatus = this.getStatusByKey(this.form.status);

      this.form.status = status.key;
      await this.submitWithFile("/patients", false);
      if (this.isStatusChangeError) {
        this.form.status = oldStatus.key;
      }
    }
  }

  ontransplantationDateChanged(val: string) {
    if (this.form.transplantationDate === "init") {
      return;
    }

    this.form.transplantationDate = val;
    if (val) {
      this.setPatientStatus("ТКМ выполнена");
    } else {
      this.setPatientStatus("Активация донора");
    }
  }

  protected setPatientStatus(statusName: String) {
    const patientStatus = this.getStatusByName(statusName);

    if (patientStatus) {
      this.onStatusChanged(patientStatus.key);
    }
  }

  emailNotificationHandler() {
    if (
      !this.form.firstName ||
      !this.form.lastName ||
      !this.form.middleName ||
      !this.form.birthday
    ) {
      Swal(
        this.$t("Предупреждение") as string,
        this.$t(
          "Нельзя установить режим оповещения без указания `Ф. И. О. пациента`, `Даты рождения`"
        ) as string,
        "warning"
      );
    } else {
      this.form.isEmailNotification = !this.form.isEmailNotification;
      if (this.form.isEmailNotification) {
        Swal(
          this.$t("Информация") as string,
          this.$t("Был включен режим оповещения!") as string,
          "info"
        );
        if (!this.form.emailNotificationDate) {
          let nowDate: Date = new Date();
          nowDate.setMonth(nowDate.getMonth() + 3);
          this.form.emailNotificationDate = nowDate;
          //@ts-ignore
          this.errors.remove("emailNotificationDate");
        }
      } else {
        Swal(
          this.$t("Информация") as string,
          this.$t("Был выключен режим оповещения!") as string,
          "info"
        );
        this.form.emailNotificationDate = null;
      }
    }
  }

  async submitWithFile(
    path: any,
    isGoBack = false,
    routeBackName: any = "",
    withoutHlaValidation = false
  ) {
    if (!FormHelper.hlaValidCount(this.form.hlas) && !withoutHlaValidation) {
      Swal(
        this.$t("Предупреждение") as string,
        this.$t("Нельзя сохранить пациента без указания минимум трех локусов") as string,
        "warning"
      );
    } else {
      try {
        let formData = await this.getFormDataWithFile();
        return await this.submit(
          path,
          isGoBack,
          routeBackName,
          formData,
          this.showStatusChangeError
        );
      } catch (e) {
        Swal("Ошибка", e.message, "warning");
      }
    }
  }

  async primarySearch() {
    let id =
      this.$auth.user().functions.find((t: any) => t.routeName === "PatientEdit") != null
        ? await this.submitWithFile("/patients", false)
        : this.form.id;

    if (id) {
      this.tabIndex = 1;
      //@ts-ignore
      this.$refs.DonorsTab.primarySearch(id);
    }
  }

  onStartUploadFile(fileUploaderRef: any) {
    let isNew = !this.form.id;
    this.removeFormValidation = isNew;

    this.submitWithFile("/patients", false, "", true).then(() => {
      if (
        this.form.id ||
        (this.$route.params && this.$route.params.id && this.$route.params.id != "add")
      ) {
        //@ts-ignore
        this.$refs[fileUploaderRef].setActive(this.form.id || this.$route.params.id);
        this.removeFormValidation = false;
      }
    });
  }

  handleDoctorConclusionFileChange(e: any) {
    this.doctorConclusionFile = e.file;
    this.form.doctorConclusionFileInfo = e.fileInfo;
  }

  handleUnrelatedSearchConfirmFileChange(e: any) {
    this.unrelatedSearchConfirmFile = e.file;
    this.form.unrelatedSearchConfirmFileInfo = e.fileInfo;
  }

  handlePersonalDataConfirmFileChange(e: any) {
    this.personalDataConfirmFile = e.file;
    this.form.personalDataConfirmFileInfo = e.fileInfo;
  }

  get emailNotificationLabel() {
    return this.form.isEmailNotification ? this.$t("Активен") : this.$t("Не активен");
  }

  async rejectTc() {
    this.isStatusChangeError = false;

    var errors = this.findDonorErrors();

    if (errors.length == 0) {
      await axios
        .post("/Patients/RejectTC", this.form)
        .then((response) => {
          Swal(
            this.$t("Информация") as string,
            this.$t(
              "Установлен статус `Отказ ТЦ`. Карточка пациента была сохранена"
            ) as string,
            "info"
          );
        })
        .catch((error) => {
          EventBus.$emit("error", {
            msg: this.$t("В процессе сохранения произошла ошибка!"),
          });
          this.isStatusChangeError = true;
        });
    } else {
      Swal(
        this.$t("Для смены статуса заполните поля") as string,
        `</br> ${errors}`,
        "warning"
      );
      this.isStatusChangeError = true;
    }
  }

  async findDonor() {
    this.isStatusChangeError = false;

    var errors = this.findDonorErrors();

    if (errors.length == 0) {
      await axios
        .post("/Patients/FindDonor", this.form)
        .then((response) => {
          Swal(
            this.$t("Информация") as string,
            this.$t(
              "Установлен статус `Поиск донора`. Карточка пациента была сохранена"
            ) as string,
            "info"
          );
          this.$router.push({
            path:
              "/patients?column=createDate&orderby=desc" +
              (this.$auth.user().isRdkm ? "&status=2" : ""),
          });
        })
        .catch((error) => {
          EventBus.$emit("error", {
            msg: this.$t("В процессе сохранения произошла ошибка!"),
          });
          this.isStatusChangeError = true;
        });
    } else {
      this.highlightAllLabels(errors);
      Swal(this.$t("Для поиска донора заполните поля") as string, `${errors}`, "warning");
      this.isStatusChangeError = true;
    }
  }

  findDonorErrors() {
    const hlaValuesCount = this.form.hlas.filter(function (item: any) {
      return item.secondAllele && item.firstAllele;
    }).length;
    var fields = "";

    if (!this.form.lastName) fields += "</br><strong>" + this.$t("Фамилия") + "</strong>";
    if (!this.form.firstName) fields += "</br><strong>" + this.$t("Имя") + "</strong>";
    if (!this.form.middleName)
      fields += "</br><strong>" + this.$t("Отчество") + "</strong>";
    if (!this.form.birthday)
      fields += "</br><strong>" + this.$t("Дата рождения") + "</strong>";
    if (!this.form.gender) fields += "</br><strong>" + this.$t("Пол") + "</strong>";
    if (!this.form.weight) fields += "</br><strong>" + this.$t("Вес") + "</strong>";
    if (!this.form.bloodType)
      fields += "</br><strong>" + this.$t("Группа крови") + "</strong>";
    if (!this.form.rh) fields += "</br><strong>" + this.$t("Резус фактор") + "</strong>";
    if (!this.form.diagnosisId && !this.form.diagnosis)
      fields += "</br><strong>" + this.$t("Диагноз") + "</strong>";
    if (hlaValuesCount != 5 && hlaValuesCount != 6)
      fields += "</br>" + this.$t("Полного HLA ALLELE-1 и HLA ALLELE-2 фенотипа");

    return fields;
  }

  private ConvertCheckBoxValueToBoolean(val: any) {
    return val === "true" || val === true;
  }

  get showDoctorConclusionFile() {
    return this.ConvertCheckBoxValueToBoolean(this.form.hasDoctorConclusion);
  }

  get showUnrelatedSearchConfirmFile() {
    return this.ConvertCheckBoxValueToBoolean(this.form.hasUnrelatedSearchConfirm);
  }

  get showPersonalDataConfirmFile() {
    return this.ConvertCheckBoxValueToBoolean(this.form.hasPersonalDataConfirm);
  }
}
